import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Alert,
} from '@mui/material';

const ConfirmMerchantModal = ({ open, onClose, onConfirm, merchantName, loading }) => {
  const [inputValue, setInputValue] = useState('');

  const isMatch =
    inputValue.trim().toLowerCase() === (merchantName || '').trim().toLowerCase();

  const handleConfirm = () => {
    if (isMatch) {
      onConfirm();
      setInputValue('');
    }
  };

  const handleClose = () => {
    setInputValue('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirm-merchant-title"
    >
      <DialogTitle id="confirm-merchant-title">Confirm Menu Import</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This will overwrite the merchant&apos;s on-device menu. This action cannot be undone.
        </Alert>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Type <strong>{merchantName}</strong> to confirm.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Merchant name"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          variant="outlined"
          size="small"
          inputProps={{ 'aria-label': 'Type merchant name to confirm' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={!isMatch || loading}
        >
          {loading ? 'Importing…' : 'Confirm Import'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmMerchantModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  merchantName: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default ConfirmMerchantModal;
